// src/pages/Dashboard/Admin/DetailsAdherents/components/IdentityPanel.jsx

import React from "react";
import DashboardInfoGrid from "./DashboardInfoGrid";

import {
  computeAge,
  formatDate,
  formatDateTime,
} from "../utils/adherentDashboardUtils";

export default function IdentityPanel({ adherent }) {
  const age = computeAge(adherent?.date_naissance);

  return (
    <div className="space-y-4">
      <DashboardInfoGrid
        items={[
          { label: "Nom", value: adherent?.nom },
          { label: "Prénom", value: adherent?.prenom },
          { label: "Genre", value: adherent?.genre },
          {
            label: "Date de naissance",
            value: formatDate(adherent?.date_naissance),
          },
          { label: "Âge", value: age !== null ? `${age} ans` : "—" },
          { label: "Lieu de naissance", value: adherent?.lieu_naissance },
          { label: "Email principal", value: adherent?.email },
          { label: "Email secondaire", value: adherent?.email_secondaire },
          { label: "Téléphone principal", value: adherent?.tel },
          { label: "Téléphone secondaire", value: adherent?.tel_secondaire },
          {
            label: "Adresse",
            value: [adherent?.adresse, adherent?.cp, adherent?.commune]
              .filter(Boolean)
              .join(" "),
          },
          { label: "Représentant légal", value: adherent?.representant_legal },
          { label: "N° licence", value: adherent?.licence_number },
          { label: "Saison active", value: adherent?.saison_active },
          { label: "N° Pass’Sport", value: adherent?.passsport_number },
          { label: "N° Pass+", value: adherent?.passplus_number },
          { label: "N° Labaz", value: adherent?.labaz_number },
          { label: "Format ANCV", value: adherent?.ancv_format },
          { label: "Montant ANCV (€)", value: adherent?.ancv_montant },
          {
            label: "Poids",
            value: adherent?.poids ? `${adherent.poids} kg` : "—",
          },
          {
            label: "Autorisation photo",
            value: adherent?.autorisation_photo ? "Oui" : "Non",
          },
          { label: "Créé le", value: formatDateTime(adherent?.createdAt) },
          {
            label: "Mis à jour le",
            value: formatDateTime(adherent?.updatedAt),
          },
        ]}
      />

      <div className="grid gap-4 lg:grid-cols-2">
        <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/60">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">
            Notes adhérent
          </p>

          <p className="mt-2 whitespace-pre-wrap text-sm leading-6 text-slate-700 dark:text-slate-300">
            {adherent?.notes_adherent || "—"}
          </p>
        </div>

        <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/60">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">
            Notes enseignant
          </p>

          <p className="mt-2 whitespace-pre-wrap text-sm leading-6 text-slate-700 dark:text-slate-300">
            {adherent?.notes_enseignant || "—"}
          </p>
        </div>
      </div>
    </div>
  );
}
